import type { TableSemanticSchema } from './types';

export const SwotSchema: TableSemanticSchema = {
  id: 'swot',
  name: 'SWOT Analysis',
  description:
    'Four-quadrant strategic analysis. Items carry impact/likelihood scoring, timeframe, and cross-links so downstream frameworks (risk matrix, Gantt) can reference them.',
  cells: [
    { id: 'strengths', label: 'Strengths', row: 0, col: 0, accent: '#16a34a' },
    { id: 'weaknesses', label: 'Weaknesses', row: 0, col: 1, accent: '#f59e0b' },
    { id: 'opportunities', label: 'Opportunities', row: 1, col: 0, accent: '#2563eb' },
    { id: 'threats', label: 'Threats', row: 1, col: 1, accent: '#dc2626' },
  ],
  itemFields: [
    { key: 'category', label: 'Category', kind: 'enum', required: true,
      options: [
        { value: 'strengths', label: 'Strength' },
        { value: 'weaknesses', label: 'Weakness' },
        { value: 'opportunities', label: 'Opportunity' },
        { value: 'threats', label: 'Threat' },
      ] },
    { key: 'impact', label: 'Impact', kind: 'number', description: '1 (low) to 5 (high)' },
    { key: 'likelihood', label: 'Likelihood', kind: 'number', description: '1 (rare) to 5 (near-certain)' },
    { key: 'timeframe', label: 'Timeframe', kind: 'enum',
      options: [
        { value: 'now', label: 'Now' },
        { value: 'quarter', label: 'This quarter' },
        { value: 'year', label: 'This year' },
        { value: 'long_term', label: 'Long term' },
      ] },
    { key: 'linkedTo', label: 'Linked Items', kind: 'id-list',
      description: 'Cross-framework links — a weakness can link to a risk, a threat to a Gantt mitigation task, etc.' },
  ],
  renderingHints: {
    layout: 'quadrant',
    cellColors: {
      strengths: '#dcfce7',
      weaknesses: '#fef3c7',
      opportunities: '#dbeafe',
      threats: '#fee2e2',
    },
  },
};
